import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["input", "preview", "container", "label"]

  connect() {
    this.toggleVisibility()
  }

  preview(event) {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewTarget.src = e.target.result
        this.containerTarget.classList.remove("hidden")
        if (this.hasLabelTarget) {
            this.labelTarget.innerText = "New Image Selection"
        }
      }
      reader.readAsDataURL(file)
    }
  }

  toggleVisibility() {
    // Hide container if no src and no file selected (initial state empty)
    // But we might have a persisted image from server rendering
    // So we rely on the view to set initial state classes or presence of image
  }
}
